module.exports = __webpack_public_path__ + "static/img/ico4.383331e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico4.png
// module id = O0y5
// module chunks = 1